export default class {
	constructor() {
		this.toggler  = document.querySelector('.footer__network-toggle');
		this.network  = document.querySelector('.footer__network');
		this.networks = document.querySelector('.footer__col--networks');

		if ( ! this.toggler || ! this.network || ! this.networks ) {
			return;
		}

		this.activeTogglerClass = 'footer__network-toggle--active';
		this.activeClass = 'footer__col--network-active';
		this.activeNetworkClass = 'footer__network--active';
		this.activeNetworksClass = 'footer__col--active';
		this.slideDuration = 400;

		if (this.toggler) {
			this.toggler.addEventListener('click', (e) => {
				e.preventDefault();
				this.toggle();
			});
		}

		if ( window.location.hash && window.location.hash === `#${this.network.id}` ) {

			this.activate();
		} else {
			this.networks.style.display = 'none';
			this.deactivate();
		}

		this.networks.addEventListener('transitionend', (e) => {
			if ( e.propertyName === 'height' ) {
				requestAnimationFrame(() => {
					this.networks.style.opacity = '';
					this.networks.style.height = '';

					if ( ! this.active ) {
						this.networks.style.display = 'none';
					}
				});
			}
		});
	}

	toggle() {
		return this.active ? this.deactivate() : this.activate();
	}

	activate() {
		this.active = true;
		this.toggler.classList.add(this.activeTogglerClass);

		this.networks.style.height   = '';
		this.networks.style.display  = 'block';
		this.networks.style.position = 'absolute';
		this.networks.style.opacity  = '0';

		let height = this.networks.offsetHeight;

		let transitionend = () => {
			window.scrollTo( {
				left: 0,
				top: window.pageYOffset + this.network.getBoundingClientRect().top,
				behavior: 'smooth'
			} );

			this.networks.removeEventListener( 'transitionend', transitionend );
		}

		this.networks.addEventListener( 'transitionend', transitionend );

		requestAnimationFrame(() => {
			this.networks.style.height = 0;

			requestAnimationFrame(() => {
				this.networks.style.position = '';
				this.networks.style.opacity = 1;
				this.networks.style.height = `${height}px`;
				this.networks.classList.add(this.activeNetworksClass);
				this.network.classList.add(this.activeNetworkClass);
			});
		});

		this.network.dispatchEvent( new CustomEvent( 'kendal:footer:activate' ) );
	}

	deactivate() {
		this.active = false;
		this.toggler.classList.remove(this.activeTogglerClass);
		this.network.classList.remove(this.activeNetworkClass);
		this.networks.classList.remove(this.activeNetworksClass);

		this.networks.style.height = `${this.network.offsetHeight}px`;

		requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				this.networks.style.height = '0';
				this.networks.style.opacity = '0';
			});
		});

		this.network.dispatchEvent( new CustomEvent( 'kendal:footer:deactivate' ) );
	}
}
